import { useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { DefaultContext } from '../../../contexts/default';
import masks from '../../../helpers/utils/masks';
import Money from '../../../helpers/utils/money/money';
import PreAlert from '../../../helpers/utils/preAlert';
import api from '../../../services/api';
import Button from '../../bootstrap/Button';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import Spinner from '../../bootstrap/Spinner';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import Label from '../../bootstrap/forms/Label';

const ModalRecharge = ({ open, setIsOpen, beneficiary, establishmentId, onSaved }) => {
  const { onShowAlert } = useContext(DefaultContext);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: { value: '' },
    validate: values => !values.value ? { value: 'Informe o valor da recarga' } : {},
    onSubmit: async values => {
      const value = Number(values.value.replace(/[,.]/g, ''));
      if (!Number.isSafeInteger(value) || value <= 0) {
        onShowAlert(PreAlert.error('Informe um valor válido'));
        return;
      }

      setLoading(true);
      try {
        await api.post(`routes/beneficiaries/${beneficiary.beneficiaryId}/recharges`, {
          establishmentId,
          value,
          payment_type: 10,
        });
        onShowAlert(PreAlert.success('Recarga realizada com sucesso'));
        setIsOpen(false);
        onSaved();
      } catch (error) {
        const message = error?.response?.data?.message || 'Não foi possível realizar a recarga';
        onShowAlert(PreAlert.error(message));
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (open) formik.resetForm();
  }, [open]);

  return (
    <Modal
      id='modal-beneficiary-recharge'
      titleId='beneficiary-recharge-title'
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop
      isCentered
      size='sm'>
      <ModalHeader setIsOpen={setIsOpen}>
        <ModalTitle id='beneficiary-recharge-title'>Recarga</ModalTitle>
      </ModalHeader>
      <ModalBody className='p-5'>
        <form onSubmit={formik.handleSubmit}>
          <FormGroup id='available-balance' label='Saldo disponível' className='mb-4'>
            <Label>{Money.centsToMaskMoney(beneficiary?.balance || 0)}</Label>
          </FormGroup>
          <FormGroup id='value' label='Adicionar saldo' className='mb-4'>
            <Input
              id='value'
              value={masks.money(formik.values.value)}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isValid={formik.isValid}
              isTouched={formik.touched.value}
              invalidFeedback={formik.errors.value}
            />
          </FormGroup>
          <div className='d-flex justify-content-end gap-2'>
            <Button color='danger' icon='cancel' onClick={() => setIsOpen(false)}>Cancelar</Button>
            <Button type='submit' color='success' icon='check' isDisable={!formik.isValid || loading}>
              {loading && <Spinner color='light' inButton isGrow isSmall size={10} tag='span' />}
              {loading ? ' Processando...' : 'Adicionar'}
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default ModalRecharge;
